export default __webpack_public_path__ + "static/media/f01.c76ba7e8.svg";